<template>
    <v-list-item :to="{ name: 'N_Capacitor discharge' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-electric-switch</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title><v-icon small>mdi-timer-sand</v-icon> Capacitor discharge</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemCapacitorDischarge',
    props: {
        disabled: Boolean,
    }
}
</script>